import { useMemo } from "react";

import {
  PERMISSION_ACTION,
  PERMISSION_MODULE,
  type PermissionAction,
  type PermissionModule,
} from "./permissionModules";
import { useCheckPermission } from "./useCheckPermission";

export type ModulePermissionAction = PermissionAction;

export type { PermissionAction, PermissionModule };
export { PERMISSION_ACTION, PERMISSION_MODULE } from "./permissionModules";

/** Seeder permission name, e.g. `Booking_Edit`. */
export const modulePermissionName = (
  module: PermissionModule,
  action: PermissionAction
): string => `${module}_${action}`;

export const useModulePermissions = (module?: PermissionModule) => {
  const { checkPermission } = useCheckPermission();

  return useMemo(
    () => {
      if (!module) {
        return {
          canList: true,
          canAdd: true,
          canEdit: true,
          canDelete: true,
        };
      }

      return {
      canList: checkPermission(modulePermissionName(module, PERMISSION_ACTION.LIST)),
      canAdd: checkPermission(modulePermissionName(module, PERMISSION_ACTION.ADD)),
      canEdit: checkPermission(modulePermissionName(module, PERMISSION_ACTION.EDIT)),
      canDelete: checkPermission(modulePermissionName(module, PERMISSION_ACTION.DELETE)),
    };
    },
    [checkPermission, module]
  );
};
